import * as colors from "../constants/colors";
import * as languages from "../constants/languages";
import { english, spanish } from "../constants/strings";
import { css, StyleSheet } from "aphrodite";
import { Container, Column, Row } from "../grid";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		paddingTop: 30,
		paddingBottom: 32,

		fontFamily: "Arial",
		fontSize: 12,
		lineHeight: 1.5,
	},
	outerContainer: {
		backgroundColor: colors.babyBlue,
		position: "absolute",
		bottom: 0,
		left: 0,
		width: "100%",
		"@media print": {
			display: "none",
		},
	},
});

export default class FooterRow extends PureComponent {
	static propTypes = {
		language: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);

		this.strings = props.language === languages.es ? spanish : english;
	}

	render() {
		return (
			<footer className={css(styles.outerContainer)}>
				<Container maxWidth={1092}>
					<Row>
						<Column>
							<div
								className={css(styles.container)}
								dangerouslySetInnerHTML={{ __html: this.strings.footerText }}
							/>
						</Column>
					</Row>
				</Container>
			</footer>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/FooterRow.js